/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import {toggleArrayValue} from '../helpers/customDateFilters';
import OptionAccordion from './OptionAccordion';
import DateAccordion from './DateAccordion';
import FiltersWrapper from './FiltersWrapper';
import {renderServices} from '../helpers/renderServicies';
import AppliedFilters from './AppliedFilters';
import {DualRangeSlider} from './Sliders/DualRangeSlider';

export const timeOptions = [
  {value: 'today', label: 'Today'},
  {value: 'yesterday', label: 'Yesterday'},
  {value: 'seven_days', label: 'Last 7 days'},
  {value: 'this_month', label: 'This Month'},
  {value: 'last_month', label: 'Last Month'},
  {value: 'last_three_month', label: 'Last 3 Months'},
  {value: 'last_six_month', label: 'Last 6 Months'},
  {value: 'specificDateRange', label: 'Specific Date Range'},
];

export default function Filter({
  openFilter,
  setOpenFilter,
  handleFilter,
  resetUrl,
  filterOptions = [],
  hideDateFilter,
  customClasses,
  onFilterStateChange,
  isRiskScore,
  isAmount,
}) {
  const [selectedTimeOption, setSelectedTimeOption] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState(() =>
    filterOptions.reduce((acc, option) => {
      acc[option?.name] = [];
      return acc;
    }, {}),
  );

  const [accordions, setAccordions] = useState(() =>
    filterOptions.reduce(
      (acc, option) => {
        acc[option.name] = false;
        return acc;
      },
      {date: false, risk_score: false, amount: false},
    ),
  );

  const [dateFilter, setDateFilter] = useState({
    start: '',
    end: '',
  });
  const [rangeFilters, setRangeFilter] = useState({
    risk_score_min: '',
    risk_score_max: '',
    amount_min: '',
    amount_max: '',
  });
  const handleToggleOption = (optionName, value) => {
    if (optionName === 'status') {
      setSelectedOptions(prevSelected => ({
        ...prevSelected,
        [optionName]: prevSelected[optionName]?.includes(value) ? [] : [value],
      }));
    } else {
      setSelectedOptions(prevSelected => ({
        ...prevSelected,
        [optionName]: toggleArrayValue(prevSelected[optionName] || [], value),
      }));
    }
  };
  const toggleAccordion = accordionName => {
    setAccordions(prevAccordions => ({
      ...Object.keys(prevAccordions || {})?.reduce((acc, name) => {
        acc[name] = name === accordionName;
        return acc;
      }, {}),
    }));
  };
  const handleApplyClick = () => {
    const selectedOptionsToSend = {
      ...rangeFilters,
      ...dateFilter,
      ...filterOptions.reduce((acc, option) => {
        acc[option.name] = selectedOptions[option.name] || [];
        return acc;
      }, {}),
    };

    const allValuesEmpty = Object.values(selectedOptionsToSend).every(value => {
      if (Array.isArray(value)) {
        return value.length === 0;
      } else if (typeof value === 'string') {
        return value.trim() === '';
      }
      return false;
    });

    if (allValuesEmpty) {
      toast.error('Select an item to filter by');
      return;
    }

    handleFilter(selectedOptionsToSend, false, false);
    setOpenFilter(false);
  };
  const handleResetFilters = useCallback(() => {
    setSelectedOptions(() =>
      filterOptions.reduce((acc, option) => {
        acc[option.name] = [];
        return acc;
      }, {}),
    );
    setAccordions(() =>
      filterOptions.reduce(
        (acc, option) => {
          acc[option.name] = false;
          return acc;
        },
        {date: false, risk_score: false, amount: false},
      ),
    );
    setDateFilter({
      start: '',
      end: '',
    });
    setRangeFilter({
      risk_score_min: '',
      risk_score_max: '',
      amount_min: '',
      amount_max: '',
    });
    setSelectedTimeOption(null);
    sessionStorage.removeItem('filterCount');
    resetUrl();
  }, [filterOptions, resetUrl]);
  const handleRemoveFilter = useCallback(
    (optionName, value) => {
      if (optionName === 'date') {
        setDateFilter({
          start: '',
          end: '',
        });
        setSelectedTimeOption(null);
      } else if (value) {
        setSelectedOptions(prevSelected => ({
          ...prevSelected,
          [optionName]: prevSelected[optionName].filter(item => item !== value),
        }));
      } else {
        setSelectedOptions(prevSelected => ({
          ...prevSelected,
          [optionName]: [],
        }));
        setRangeFilter({
          risk_score_min: '',
          risk_score_max: '',
          amount_min: '',
          amount_max: '',
        });
      }

      setTimeout(() => {
        const updatedOptions = {
          ...dateFilter,
          ...filterOptions.reduce((acc, option) => {
            acc[option.name] = selectedOptions[option.name] || [];
            return acc;
          }, {}),
        };

        if (optionName === 'date') {
          updatedOptions.start = '';
          updatedOptions.end = '';
        } else if (optionName && !value) {
          updatedOptions[optionName] = [];
        } else if (optionName && value) {
          updatedOptions[optionName] = updatedOptions[optionName].filter(
            item => item !== value,
          );
        }

        handleFilter(updatedOptions, false, true);
      }, 0);
    },
    [dateFilter, filterOptions, handleFilter, selectedOptions],
  );

  useEffect(() => {
    const countNonEmptyArrays = Object.values(selectedOptions).filter(
      value => Array.isArray(value) && value.length > 0,
    ).length;

    const allCount =
      selectedTimeOption?.length > 0
        ? countNonEmptyArrays + 1
        : countNonEmptyArrays;
    sessionStorage.setItem('filterCount', allCount?.toString());

    if (onFilterStateChange) {
      onFilterStateChange({
        selectedOptions,
        dateFilter,
        selectedTimeOption,
        timeOptions,
        filterOptions,
        handleRemoveFilter,
        handleClearAll: handleResetFilters,
      });
    }
  }, [
    selectedOptions,
    selectedTimeOption,
    dateFilter,
    // filterOptions,
    // onFilterStateChange,
    // handleRemoveFilter,
    // handleResetFilters,
  ]);

  const labelClassName =
    'relative flex flex-row gap-2 font-normal transition duration-500 ease-in-out cursor-pointer capitalize';
  const inputClassName =
    'w-[15px] h-[15px] rounded-sm focus-visible:outline-1 focus-visible:outline-brandBlue';

  Filter.filterProps = {
    selectedOptions,
    dateFilter,
    selectedTimeOption,
    timeOptions,
    filterOptions,
    handleRemoveFilter,
    handleClearAll: handleResetFilters,
  };

  return (
    <>
      <FiltersWrapper
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        onResetFilters={handleResetFilters}
        handleFilter={handleApplyClick}
        customClasses={customClasses}
      >
        <AppliedFilters
          selectedOptions={selectedOptions}
          dateFilter={dateFilter}
          selectedTimeOption={selectedTimeOption}
          timeOptions={timeOptions}
          filterOptions={filterOptions}
          handleRemoveFilter={handleRemoveFilter}
          handleClearAll={handleResetFilters}
        />
        <DateAccordion
          accordions={accordions}
          toggleAccordion={toggleAccordion}
          dateFilter={dateFilter}
          setDateFilter={setDateFilter}
          selectedTimeOption={selectedTimeOption}
          setSelectedTimeOption={setSelectedTimeOption}
          hideDateFilter={hideDateFilter}
        />
        {filterOptions?.map(option => (
          <OptionAccordion
            key={option?.name}
            title={option?.title}
            count={(selectedOptions[option?.name] || [])?.length}
            isOpen={accordions[option?.name]}
            onAccordionClick={() => toggleAccordion(option?.name)}
          >
            {option?.values &&
              Array.isArray(option?.values) &&
              option?.values?.map(value => (
                <label
                  key={`${option.name}-${value.value}`}
                  className={labelClassName}
                >
                  <input
                    className={inputClassName}
                    type="checkbox"
                    name={option.name}
                    value={value.value}
                    checked={selectedOptions[option.name]?.includes(
                      value.value,
                    )}
                    onChange={() =>
                      handleToggleOption(option.name, value.value)
                    }
                  />
                  {option.name === 'services' || option.name === 'service'
                    ? renderServices(value.label)
                    : value.label}
                </label>
              ))}
          </OptionAccordion>
        ))}
        {isAmount && (
          <OptionAccordion
            title="Range of Amount"
            isOpen={accordions['amount']}
            onAccordionClick={() => toggleAccordion('amount')}
          >
            <div className="flex  gap-3">
              <input
                placeholder="Min"
                value={rangeFilters.amount_min[0]}
                type="number"
                onChange={e => {
                  setSelectedOptions(prevSelected => ({
                    ...prevSelected,
                    amount_min: [e.target.value],
                    amount_max: selectedOptions?.amount_max || [
                      +e.target.value > 2 && +e.target.value + 1,
                    ],
                  }));
                  setRangeFilter(prev => ({
                    ...prev,
                    amount_min: [e.target.value],
                    amount_max: selectedOptions?.amount_max || [
                      +e.target.value > 2 && +e.target.value + 1,
                    ],
                  }));
                }}
              />
              <input
                placeholder="Max"
                type="number"
                value={rangeFilters.amount_max[0]}
                onChange={e => {
                  setSelectedOptions(prevSelected => ({
                    ...prevSelected,
                    amount_max: [e.target.value],
                    amount_min: selectedOptions?.amount_min || [
                      +e.target.value > 2 && +e.target.value - 1,
                    ],
                  }));
                  setRangeFilter(prev => ({
                    ...prev,
                    amount_max: [e.target.value],
                    amount_min: selectedOptions?.amount_min || [
                      +e.target.value > 2 && +e.target.value - 1,
                    ],
                  }));
                }}
              />
            </div>
          </OptionAccordion>
        )}
        {isRiskScore && (
          <OptionAccordion
            title="Range of Risk Score"
            isOpen={accordions['risk_score']}
            onAccordionClick={() => toggleAccordion('risk_score')}
          >
            <DualRangeSlider
              min={rangeFilters.risk_score_min[0]}
              max={rangeFilters.risk_score_max[0]}
              onChange={(type, value) => {
                const data =
                  type === 'min'
                    ? {
                        risk_score_min: [value.toString()],
                        risk_score_max: selectedOptions?.risk_score_max || [78],
                      }
                    : {
                        risk_score_max: [value.toString()],
                        risk_score_min: selectedOptions?.risk_score_min || [25],
                      };
                setSelectedOptions(prevSelected => ({
                  ...prevSelected,
                  ...data,
                }));
                setRangeFilter(prev => ({
                  ...prev,
                  ...data,
                }));
              }}
            />
          </OptionAccordion>
        )}
      </FiltersWrapper>
    </>
  );
}
